module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'psqkkam6',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
